import client from '@/shared/apis/client'
import {
  PharmacyListResponse,
  PharmacistListResponse,
} from '@/features/auth/types/pharmacy'

export const getPharmacies = async (): Promise<PharmacyListResponse> => {
  const response = await client.get<PharmacyListResponse>('/api/pharmacies/')
  return response.data
}

export const getPharmacists = async (): Promise<PharmacistListResponse> => {
  const response = await client.get<PharmacistListResponse>('/api/pharmacists/')
  return response.data
}
